import { useCallback, useState, useContext, useEffect } from "react";
import { getOrganizationPolicyCategory,addOrganizationPolicyCategory,deleteOrganizationPolicyCategory } from "./Services/AdvanceSettingService";
import { TostMsg } from "../../../App";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";


const OrgPolicyCategorys = () => {
  const [columns, setColumns] = useState(["Name", "Descriptions"]); // Columns state
  const [rows, setRows] = useState([{}]); // Rows state
  const {GUID} = useParams();
  const [editIndex, setEditIndex] = useState(null);
  const [orgPolicyList,setOrgPolicyList] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [orgPolicyId, setOrgPolicyId] = useState(null);
  const [Isloading, setIsloading] = useState(false);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
   const [data, setData] = useState({
    WFHType: "",
    Desc: "",
  });
  let SearchValue = "";

  useEffect(() => {
    GetOrgPolicys();
  }, []);

   const validateOrgPolicy = (data, index) => { 
    const newErrors = {};
    newErrors[`${index}-Name`] =
      !data.Name || data.Name.trim() === ""
        ? "Policy Name is required"
        : undefined;
    newErrors[`${index}-Description`] =
      !data.Description || data.Description.trim() === ""
        ? "Description is required"
        : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetOrgPolicys() {
    setIsloading(true); 
    try {
      let responce = await getOrganizationPolicyCategory({});
      setOrgPolicyList(responce?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgPolicyList([
      ...orgPolicyList,
      { LeaveType: "", Desc: ""},
    ]);
    setEditIndex(orgPolicyList.length); // enter edit mode for new row
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };
 
  const handleChange = (rowIdx, colName) => (e) => {
  const { value } = e.target;
  setOrgPolicyList(prevList => {
    const newList = prevList.map((item, idx) =>
      idx === rowIdx ? { ...item, [colName]: value } : item
    );
    return newList;
  });
  setData(prev => ({ ...prev, [colName]: value }));
  validateOrgPolicy({ ...orgPolicyList[rowIdx], [colName]: value }, rowIdx);
};

  const cancelOrgWfh = () => {
  GetOrgPolicys();
  setOrgPolicyList(prevList => {
    setEditIndex(null);
    const len = prevList.length;
    if (len === 0) return prevList;
    const lastItem = prevList[len - 1];
    const isEmpty = lastItem &&
      !lastItem.WFHType &&
      !lastItem.Desc ;
    if (isEmpty) {
      return prevList.slice(0, -1);
    }
    return prevList;
  });
}
  
  async function addPolicyCategory(index, data) {
    const body = {
  Id: data?.Id || 0,
  GUID: GUID,
  CreatedBy: 0,
  ModifiedBy: 0,
  OrgId: userDetails?.OrgId,
  Name: data.Name,
  Description: data.Description
    };
    try {
      await addOrganizationPolicyCategory(body);
      if (orgPolicyId) {
        alert('Org Leave Updated');
      } else {
        alert('Org Leave Added');
      }
      setOrgPolicyList([]);
      setEditIndex(null);
      GetOrgPolicys();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index) => {
    setEditIndex(index);
  };

  const handlePolicylstDelete = (Id) => {
    setOrgPolicyId(Id);
  };

   async function DeleteOrgPolicy() { 
      setIsloading(true);
      if (orgPolicyId) {
        let body = {
          Id: orgPolicyId,
        };
        try {
          let orgPolicyDeleteList = await deleteOrganizationPolicyCategory(body);
          if (orgPolicyDeleteList) {
            setIsloading(false);
            GetOrgPolicys();
          }
        } catch (error) {
          toster.current.error(ERROR_LIST.DefaultError);
        }
      }
    }


  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgPolicyList.filter((orgLoc) =>
        orgLoc.Name?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgPolicyList(filteredList);
      } else {
        GetOrgPolicys();
      }
    }, 800),
    [orgPolicyList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
        </div>
        <div className="title-text">
          <h3>Policy Category Types ({orgPolicyList?.length})</h3>
          <div className="d-flex">
          <InputText
            name="requestTitle"
            className="form-control search-grpname me-2"
            onChange={handleInputChange}
            placeholder="Search"
          />
          {!editIndex && (
            <button
              className="addaward-btn"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-bs-original-title=""
              fdprocessedid="izng1j"
              onClick={handleAddRow}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus"
                viewBox="0 0 16 16"
              >
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
              </svg>
              Policy Category
            </button>
          )}
          </div>
        </div>
        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgPolicyList?.map((data, index) => (
                <tr key={index}>
                  
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                         type="text"
                          value={data.Name}
                          onChange={handleChange(index, "Name")}
                          placeholder="Policy Name"
                          className={`form-control ${errors[`${index}-Name`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-Name`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Name`]}
                          </div>
                        )}
                      </td>

                      <td>
                        <input
                         type="text"
                          value={data.Description}
                          onChange={handleChange(index, "Description")}
                          placeholder="Descriptions"
                          className={`form-control ${errors[`${index}-Description`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-Description`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-Description`]}
                          </div>
                        )}
                      </td>
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                            onClick={() => {
                            if (validateOrgPolicy(data, index)) { 
                            addPolicyCategory(index, data);
                            setEditIndex(null);
                            }
                           }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.Name}</td>
                      <td>{data?.Description}</td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-policy"
                          onClick={() => {
                            handlePolicylstDelete(data?.Id);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-policy">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Policy?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgPolicy()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgPolicyCategorys;
